export const timezones = [
	{
		id: "Africa/Abidjan",
		value: "Africa/Abidjan",
	},
	{
		id: "Africa/Accra",
		value: "Africa/Accra",
	},
	{
		id: "Africa/Addis_Ababa",
		value: "Africa/Addis_Ababa",
	},
	{
		id: "Africa/Algiers",
		value: "Africa/Algiers",
	},
	{
		id: "Africa/Asmara",
		value: "Africa/Asmara",
	},
	{
		id: "Africa/Asmera",
		value: "Africa/Asmera",
	},
	{
		id: "Africa/Bamako",
		value: "Africa/Bamako",
	},
	{
		id: "Africa/Bangui",
		value: "Africa/Bangui",
	},
	{
		id: "Africa/Banjul",
		value: "Africa/Banjul",
	},
	{
		id: "Africa/Bissau",
		value: "Africa/Bissau",
	},
	{
		id: "Africa/Blantyre",
		value: "Africa/Blantyre",
	},
	{
		id: "Africa/Brazzaville",
		value: "Africa/Brazzaville",
	},
	{
		id: "Africa/Bujumbura",
		value: "Africa/Bujumbura",
	},
	{
		id: "Africa/Cairo",
		value: "Africa/Cairo",
	},
	{
		id: "Africa/Casablanca",
		value: "Africa/Casablanca",
	},
	{
		id: "Africa/Ceuta",
		value: "Africa/Ceuta",
	},
	{
		id: "Africa/Conakry",
		value: "Africa/Conakry",
	},
	{
		id: "Africa/Dakar",
		value: "Africa/Dakar",
	},
	{
		id: "Africa/Dar_es_Salaam",
		value: "Africa/Dar_es_Salaam",
	},
	{
		id: "Africa/Djibouti",
		value: "Africa/Djibouti",
	},
	{
		id: "Africa/Douala",
		value: "Africa/Douala",
	},
	{
		id: "Africa/El_Aaiun",
		value: "Africa/El_Aaiun",
	},
	{
		id: "Africa/Freetown",
		value: "Africa/Freetown",
	},
	{
		id: "Africa/Gaborone",
		value: "Africa/Gaborone",
	},
	{
		id: "Africa/Harare",
		value: "Africa/Harare",
	},
	{
		id: "Africa/Johannesburg",
		value: "Africa/Johannesburg",
	},
	{
		id: "Africa/Juba",
		value: "Africa/Juba",
	},
	{
		id: "Africa/Kampala",
		value: "Africa/Kampala",
	},
	{
		id: "Africa/Khartoum",
		value: "Africa/Khartoum",
	},
	{
		id: "Africa/Kigali",
		value: "Africa/Kigali",
	},
	{
		id: "Africa/Kinshasa",
		value: "Africa/Kinshasa",
	},
	{
		id: "Africa/Lagos",
		value: "Africa/Lagos",
	},
	{
		id: "Africa/Libreville",
		value: "Africa/Libreville",
	},
	{
		id: "Africa/Lome",
		value: "Africa/Lome",
	},
	{
		id: "Africa/Luanda",
		value: "Africa/Luanda",
	},
	{
		id: "Africa/Lubumbashi",
		value: "Africa/Lubumbashi",
	},
	{
		id: "Africa/Lusaka",
		value: "Africa/Lusaka",
	},
	{
		id: "Africa/Malabo",
		value: "Africa/Malabo",
	},
	{
		id: "Africa/Maputo",
		value: "Africa/Maputo",
	},
	{
		id: "Africa/Maseru",
		value: "Africa/Maseru",
	},
	{
		id: "Africa/Mbabane",
		value: "Africa/Mbabane",
	},
	{
		id: "Africa/Mogadishu",
		value: "Africa/Mogadishu",
	},
	{
		id: "Africa/Monrovia",
		value: "Africa/Monrovia",
	},
	{
		id: "Africa/Nairobi",
		value: "Africa/Nairobi",
	},
	{
		id: "Africa/Ndjamena",
		value: "Africa/Ndjamena",
	},
	{
		id: "Africa/Niamey",
		value: "Africa/Niamey",
	},
	{
		id: "Africa/Nouakchott",
		value: "Africa/Nouakchott",
	},
	{
		id: "Africa/Ouagadougou",
		value: "Africa/Ouagadougou",
	},
	{
		id: "Africa/Porto-Novo",
		value: "Africa/Porto-Novo",
	},
	{
		id: "Africa/Sao_Tome",
		value: "Africa/Sao_Tome",
	},
	{
		id: "Africa/Timbuktu",
		value: "Africa/Timbuktu",
	},
	{
		id: "Africa/Tripoli",
		value: "Africa/Tripoli",
	},
	{
		id: "Africa/Tunis",
		value: "Africa/Tunis",
	},
	{
		id: "Africa/Windhoek",
		value: "Africa/Windhoek",
	},
	{
		id: "America/Adak",
		value: "America/Adak",
	},
	{
		id: "America/Anchorage",
		value: "America/Anchorage",
	},
	{
		id: "America/Anguilla",
		value: "America/Anguilla",
	},
	{
		id: "America/Antigua",
		value: "America/Antigua",
	},
	{
		id: "America/Araguaina",
		value: "America/Araguaina",
	},
	{
		id: "America/Argentina/Buenos_Aires",
		value: "America/Argentina/Buenos_Aires",
	},
	{
		id: "America/Argentina/Catamarca",
		value: "America/Argentina/Catamarca",
	},
	{
		id: "America/Argentina/ComodRivadavia",
		value: "America/Argentina/ComodRivadavia",
	},
	{
		id: "America/Argentina/Cordoba",
		value: "America/Argentina/Cordoba",
	},
	{
		id: "America/Argentina/Jujuy",
		value: "America/Argentina/Jujuy",
	},
	{
		id: "America/Argentina/La_Rioja",
		value: "America/Argentina/La_Rioja",
	},
	{
		id: "America/Argentina/Mendoza",
		value: "America/Argentina/Mendoza",
	},
	{
		id: "America/Argentina/Rio_Gallegos",
		value: "America/Argentina/Rio_Gallegos",
	},
	{
		id: "America/Argentina/Salta",
		value: "America/Argentina/Salta",
	},
	{
		id: "America/Argentina/San_Juan",
		value: "America/Argentina/San_Juan",
	},
	{
		id: "America/Argentina/San_Luis",
		value: "America/Argentina/San_Luis",
	},
	{
		id: "America/Argentina/Tucuman",
		value: "America/Argentina/Tucuman",
	},
	{
		id: "America/Argentina/Ushuaia",
		value: "America/Argentina/Ushuaia",
	},
	{
		id: "America/Aruba",
		value: "America/Aruba",
	},
	{
		id: "America/Asuncion",
		value: "America/Asuncion",
	},
	{
		id: "America/Atikokan",
		value: "America/Atikokan",
	},
	{
		id: "America/Atka",
		value: "America/Atka",
	},
	{
		id: "America/Bahia",
		value: "America/Bahia",
	},
	{
		id: "America/Bahia_Banderas",
		value: "America/Bahia_Banderas",
	},
	{
		id: "America/Barbados",
		value: "America/Barbados",
	},
	{
		id: "America/Belem",
		value: "America/Belem",
	},
	{
		id: "America/Belize",
		value: "America/Belize",
	},
	{
		id: "America/Blanc-Sablon",
		value: "America/Blanc-Sablon",
	},
	{
		id: "America/Boa_Vista",
		value: "America/Boa_Vista",
	},
	{
		id: "America/Bogota",
		value: "America/Bogota",
	},
	{
		id: "America/Boise",
		value: "America/Boise",
	},
	{
		id: "America/Buenos_Aires",
		value: "America/Buenos_Aires",
	},
	{
		id: "America/Cambridge_Bay",
		value: "America/Cambridge_Bay",
	},
	{
		id: "America/Campo_Grande",
		value: "America/Campo_Grande",
	},
	{
		id: "America/Cancun",
		value: "America/Cancun",
	},
	{
		id: "America/Caracas",
		value: "America/Caracas",
	},
	{
		id: "America/Catamarca",
		value: "America/Catamarca",
	},
	{
		id: "America/Cayenne",
		value: "America/Cayenne",
	},
	{
		id: "America/Cayman",
		value: "America/Cayman",
	},
	{
		id: "America/Chicago",
		value: "America/Chicago",
	},
	{
		id: "America/Chihuahua",
		value: "America/Chihuahua",
	},
	{
		id: "America/Coral_Harbour",
		value: "America/Coral_Harbour",
	},
	{
		id: "America/Cordoba",
		value: "America/Cordoba",
	},
	{
		id: "America/Costa_Rica",
		value: "America/Costa_Rica",
	},
	{
		id: "America/Creston",
		value: "America/Creston",
	},
	{
		id: "America/Cuiaba",
		value: "America/Cuiaba",
	},
	{
		id: "America/Curacao",
		value: "America/Curacao",
	},
	{
		id: "America/Danmarkshavn",
		value: "America/Danmarkshavn",
	},
	{
		id: "America/Dawson",
		value: "America/Dawson",
	},
	{
		id: "America/Dawson_Creek",
		value: "America/Dawson_Creek",
	},
	{
		id: "America/Denver",
		value: "America/Denver",
	},
	{
		id: "America/Detroit",
		value: "America/Detroit",
	},
	{
		id: "America/Dominica",
		value: "America/Dominica",
	},
	{
		id: "America/Edmonton",
		value: "America/Edmonton",
	},
	{
		id: "America/Eirunepe",
		value: "America/Eirunepe",
	},
	{
		id: "America/El_Salvador",
		value: "America/El_Salvador",
	},
	{
		id: "America/Ensenada",
		value: "America/Ensenada",
	},
	{
		id: "America/Fort_Nelson",
		value: "America/Fort_Nelson",
	},
	{
		id: "America/Fort_Wayne",
		value: "America/Fort_Wayne",
	},
	{
		id: "America/Fortaleza",
		value: "America/Fortaleza",
	},
	{
		id: "America/Glace_Bay",
		value: "America/Glace_Bay",
	},
	{
		id: "America/Godthab",
		value: "America/Godthab",
	},
	{
		id: "America/Goose_Bay",
		value: "America/Goose_Bay",
	},
	{
		id: "America/Grand_Turk",
		value: "America/Grand_Turk",
	},
	{
		id: "America/Grenada",
		value: "America/Grenada",
	},
	{
		id: "America/Guadeloupe",
		value: "America/Guadeloupe",
	},
	{
		id: "America/Guatemala",
		value: "America/Guatemala",
	},
	{
		id: "America/Guayaquil",
		value: "America/Guayaquil",
	},
	{
		id: "America/Guyana",
		value: "America/Guyana",
	},
	{
		id: "America/Halifax",
		value: "America/Halifax",
	},
	{
		id: "America/Havana",
		value: "America/Havana",
	},
	{
		id: "America/Hermosillo",
		value: "America/Hermosillo",
	},
	{
		id: "America/Indiana/Indianapolis",
		value: "America/Indiana/Indianapolis",
	},
	{
		id: "America/Indiana/Knox",
		value: "America/Indiana/Knox",
	},
	{
		id: "America/Indiana/Marengo",
		value: "America/Indiana/Marengo",
	},
	{
		id: "America/Indiana/Petersburg",
		value: "America/Indiana/Petersburg",
	},
	{
		id: "America/Indiana/Tell_City",
		value: "America/Indiana/Tell_City",
	},
	{
		id: "America/Indiana/Vevay",
		value: "America/Indiana/Vevay",
	},
	{
		id: "America/Indiana/Vincennes",
		value: "America/Indiana/Vincennes",
	},
	{
		id: "America/Indiana/Winamac",
		value: "America/Indiana/Winamac",
	},
	{
		id: "America/Indianapolis",
		value: "America/Indianapolis",
	},
	{
		id: "America/Inuvik",
		value: "America/Inuvik",
	},
	{
		id: "America/Iqaluit",
		value: "America/Iqaluit",
	},
	{
		id: "America/Jamaica",
		value: "America/Jamaica",
	},
	{
		id: "America/Jujuy",
		value: "America/Jujuy",
	},
	{
		id: "America/Juneau",
		value: "America/Juneau",
	},
	{
		id: "America/Kentucky/Louisville",
		value: "America/Kentucky/Louisville",
	},
	{
		id: "America/Kentucky/Monticello",
		value: "America/Kentucky/Monticello",
	},
	{
		id: "America/Knox_IN",
		value: "America/Knox_IN",
	},
	{
		id: "America/Kralendijk",
		value: "America/Kralendijk",
	},
	{
		id: "America/La_Paz",
		value: "America/La_Paz",
	},
	{
		id: "America/Lima",
		value: "America/Lima",
	},
	{
		id: "America/Los_Angeles",
		value: "America/Los_Angeles",
	},
	{
		id: "America/Louisville",
		value: "America/Louisville",
	},
	{
		id: "America/Lower_Princes",
		value: "America/Lower_Princes",
	},
	{
		id: "America/Maceio",
		value: "America/Maceio",
	},
	{
		id: "America/Managua",
		value: "America/Managua",
	},
	{
		id: "America/Manaus",
		value: "America/Manaus",
	},
	{
		id: "America/Marigot",
		value: "America/Marigot",
	},
	{
		id: "America/Martinique",
		value: "America/Martinique",
	},
	{
		id: "America/Matamoros",
		value: "America/Matamoros",
	},
	{
		id: "America/Mazatlan",
		value: "America/Mazatlan",
	},
	{
		id: "America/Mendoza",
		value: "America/Mendoza",
	},
	{
		id: "America/Menominee",
		value: "America/Menominee",
	},
	{
		id: "America/Merida",
		value: "America/Merida",
	},
	{
		id: "America/Metlakatla",
		value: "America/Metlakatla",
	},
	{
		id: "America/Mexico_City",
		value: "America/Mexico_City",
	},
	{
		id: "America/Miquelon",
		value: "America/Miquelon",
	},
	{
		id: "America/Moncton",
		value: "America/Moncton",
	},
	{
		id: "America/Monterrey",
		value: "America/Monterrey",
	},
	{
		id: "America/Montevideo",
		value: "America/Montevideo",
	},
	{
		id: "America/Montreal",
		value: "America/Montreal",
	},
	{
		id: "America/Montserrat",
		value: "America/Montserrat",
	},
	{
		id: "America/Nassau",
		value: "America/Nassau",
	},
	{
		id: "America/New_York",
		value: "America/New_York",
	},
	{
		id: "America/Nipigon",
		value: "America/Nipigon",
	},
	{
		id: "America/Nome",
		value: "America/Nome",
	},
	{
		id: "America/Noronha",
		value: "America/Noronha",
	},
	{
		id: "America/North_Dakota/Beulah",
		value: "America/North_Dakota/Beulah",
	},
	{
		id: "America/North_Dakota/Center",
		value: "America/North_Dakota/Center",
	},
	{
		id: "America/North_Dakota/New_Salem",
		value: "America/North_Dakota/New_Salem",
	},
	{
		id: "America/Ojinaga",
		value: "America/Ojinaga",
	},
	{
		id: "America/Panama",
		value: "America/Panama",
	},
	{
		id: "America/Pangnirtung",
		value: "America/Pangnirtung",
	},
	{
		id: "America/Paramaribo",
		value: "America/Paramaribo",
	},
	{
		id: "America/Phoenix",
		value: "America/Phoenix",
	},
	{
		id: "America/Port-au-Prince",
		value: "America/Port-au-Prince",
	},
	{
		id: "America/Port_of_Spain",
		value: "America/Port_of_Spain",
	},
	{
		id: "America/Porto_Acre",
		value: "America/Porto_Acre",
	},
	{
		id: "America/Porto_Velho",
		value: "America/Porto_Velho",
	},
	{
		id: "America/Puerto_Rico",
		value: "America/Puerto_Rico",
	},
	{
		id: "America/Punta_Arenas",
		value: "America/Punta_Arenas",
	},
	{
		id: "America/Rainy_River",
		value: "America/Rainy_River",
	},
	{
		id: "America/Rankin_Inlet",
		value: "America/Rankin_Inlet",
	},
	{
		id: "America/Recife",
		value: "America/Recife",
	},
	{
		id: "America/Regina",
		value: "America/Regina",
	},
	{
		id: "America/Resolute",
		value: "America/Resolute",
	},
	{
		id: "America/Rio_Branco",
		value: "America/Rio_Branco",
	},
	{
		id: "America/Rosario",
		value: "America/Rosario",
	},
	{
		id: "America/Santa_Isabel",
		value: "America/Santa_Isabel",
	},
	{
		id: "America/Santarem",
		value: "America/Santarem",
	},
	{
		id: "America/Santiago",
		value: "America/Santiago",
	},
	{
		id: "America/Santo_Domingo",
		value: "America/Santo_Domingo",
	},
	{
		id: "America/Sao_Paulo",
		value: "America/Sao_Paulo",
	},
	{
		id: "America/Scoresbysund",
		value: "America/Scoresbysund",
	},
	{
		id: "America/Shiprock",
		value: "America/Shiprock",
	},
	{
		id: "America/Sitka",
		value: "America/Sitka",
	},
	{
		id: "America/St_Barthelemy",
		value: "America/St_Barthelemy",
	},
	{
		id: "America/St_Johns",
		value: "America/St_Johns",
	},
	{
		id: "America/St_Kitts",
		value: "America/St_Kitts",
	},
	{
		id: "America/St_Lucia",
		value: "America/St_Lucia",
	},
	{
		id: "America/St_Thomas",
		value: "America/St_Thomas",
	},
	{
		id: "America/St_Vincent",
		value: "America/St_Vincent",
	},
	{
		id: "America/Swift_Current",
		value: "America/Swift_Current",
	},
	{
		id: "America/Tegucigalpa",
		value: "America/Tegucigalpa",
	},
	{
		id: "America/Thule",
		value: "America/Thule",
	},
	{
		id: "America/Thunder_Bay",
		value: "America/Thunder_Bay",
	},
	{
		id: "America/Tijuana",
		value: "America/Tijuana",
	},
	{
		id: "America/Toronto",
		value: "America/Toronto",
	},
	{
		id: "America/Tortola",
		value: "America/Tortola",
	},
	{
		id: "America/Vancouver",
		value: "America/Vancouver",
	},
	{
		id: "America/Virgin",
		value: "America/Virgin",
	},
	{
		id: "America/Whitehorse",
		value: "America/Whitehorse",
	},
	{
		id: "America/Winnipeg",
		value: "America/Winnipeg",
	},
	{
		id: "America/Yakutat",
		value: "America/Yakutat",
	},
	{
		id: "America/Yellowknife",
		value: "America/Yellowknife",
	},
	{
		id: "Antarctica/Casey",
		value: "Antarctica/Casey",
	},
	{
		id: "Antarctica/Davis",
		value: "Antarctica/Davis",
	},
	{
		id: "Antarctica/DumontDUrville",
		value: "Antarctica/DumontDUrville",
	},
	{
		id: "Antarctica/Macquarie",
		value: "Antarctica/Macquarie",
	},
	{
		id: "Antarctica/Mawson",
		value: "Antarctica/Mawson",
	},
	{
		id: "Antarctica/McMurdo",
		value: "Antarctica/McMurdo",
	},
	{
		id: "Antarctica/Palmer",
		value: "Antarctica/Palmer",
	},
	{
		id: "Antarctica/Rothera",
		value: "Antarctica/Rothera",
	},
	{
		id: "Antarctica/South_Pole",
		value: "Antarctica/South_Pole",
	},
	{
		id: "Antarctica/Syowa",
		value: "Antarctica/Syowa",
	},
	{
		id: "Antarctica/Troll",
		value: "Antarctica/Troll",
	},
	{
		id: "Antarctica/Vostok",
		value: "Antarctica/Vostok",
	},
	{
		id: "Arctic/Longyearbyen",
		value: "Arctic/Longyearbyen",
	},
	{
		id: "Asia/Aden",
		value: "Asia/Aden",
	},
	{
		id: "Asia/Almaty",
		value: "Asia/Almaty",
	},
	{
		id: "Asia/Amman",
		value: "Asia/Amman",
	},
	{
		id: "Asia/Anadyr",
		value: "Asia/Anadyr",
	},
	{
		id: "Asia/Aqtau",
		value: "Asia/Aqtau",
	},
	{
		id: "Asia/Aqtobe",
		value: "Asia/Aqtobe",
	},
	{
		id: "Asia/Ashgabat",
		value: "Asia/Ashgabat",
	},
	{
		id: "Asia/Ashkhabad",
		value: "Asia/Ashkhabad",
	},
	{
		id: "Asia/Atyrau",
		value: "Asia/Atyrau",
	},
	{
		id: "Asia/Baghdad",
		value: "Asia/Baghdad",
	},
	{
		id: "Asia/Bahrain",
		value: "Asia/Bahrain",
	},
	{
		id: "Asia/Baku",
		value: "Asia/Baku",
	},
	{
		id: "Asia/Bangkok",
		value: "Asia/Bangkok",
	},
	{
		id: "Asia/Barnaul",
		value: "Asia/Barnaul",
	},
	{
		id: "Asia/Beirut",
		value: "Asia/Beirut",
	},
	{
		id: "Asia/Bishkek",
		value: "Asia/Bishkek",
	},
	{
		id: "Asia/Brunei",
		value: "Asia/Brunei",
	},
	{
		id: "Asia/Calcutta",
		value: "Asia/Calcutta",
	},
	{
		id: "Asia/Chita",
		value: "Asia/Chita",
	},
	{
		id: "Asia/Choibalsan",
		value: "Asia/Choibalsan",
	},
	{
		id: "Asia/Chongqing",
		value: "Asia/Chongqing",
	},
	{
		id: "Asia/Chungking",
		value: "Asia/Chungking",
	},
	{
		id: "Asia/Colombo",
		value: "Asia/Colombo",
	},
	{
		id: "Asia/Dacca",
		value: "Asia/Dacca",
	},
	{
		id: "Asia/Damascus",
		value: "Asia/Damascus",
	},
	{
		id: "Asia/Dhaka",
		value: "Asia/Dhaka",
	},
	{
		id: "Asia/Dili",
		value: "Asia/Dili",
	},
	{
		id: "Asia/Dubai",
		value: "Asia/Dubai",
	},
	{
		id: "Asia/Dushanbe",
		value: "Asia/Dushanbe",
	},
	{
		id: "Asia/Famagusta",
		value: "Asia/Famagusta",
	},
	{
		id: "Asia/Gaza",
		value: "Asia/Gaza",
	},
	{
		id: "Asia/Harbin",
		value: "Asia/Harbin",
	},
	{
		id: "Asia/Hebron",
		value: "Asia/Hebron",
	},
	{
		id: "Asia/Ho_Chi_Minh",
		value: "Asia/Ho_Chi_Minh",
	},
	{
		id: "Asia/Hong_Kong",
		value: "Asia/Hong_Kong",
	},
	{
		id: "Asia/Hovd",
		value: "Asia/Hovd",
	},
	{
		id: "Asia/Irkutsk",
		value: "Asia/Irkutsk",
	},
	{
		id: "Asia/Istanbul",
		value: "Asia/Istanbul",
	},
	{
		id: "Asia/Jakarta",
		value: "Asia/Jakarta",
	},
	{
		id: "Asia/Jayapura",
		value: "Asia/Jayapura",
	},
	{
		id: "Asia/Jerusalem",
		value: "Asia/Jerusalem",
	},
	{
		id: "Asia/Kabul",
		value: "Asia/Kabul",
	},
	{
		id: "Asia/Kamchatka",
		value: "Asia/Kamchatka",
	},
	{
		id: "Asia/Karachi",
		value: "Asia/Karachi",
	},
	{
		id: "Asia/Kashgar",
		value: "Asia/Kashgar",
	},
	{
		id: "Asia/Kathmandu",
		value: "Asia/Kathmandu",
	},
	{
		id: "Asia/Katmandu",
		value: "Asia/Katmandu",
	},
	{
		id: "Asia/Khandyga",
		value: "Asia/Khandyga",
	},
	{
		id: "Asia/Kolkata",
		value: "Asia/Kolkata",
	},
	{
		id: "Asia/Krasnoyarsk",
		value: "Asia/Krasnoyarsk",
	},
	{
		id: "Asia/Kuala_Lumpur",
		value: "Asia/Kuala_Lumpur",
	},
	{
		id: "Asia/Kuching",
		value: "Asia/Kuching",
	},
	{
		id: "Asia/Kuwait",
		value: "Asia/Kuwait",
	},
	{
		id: "Asia/Macao",
		value: "Asia/Macao",
	},
	{
		id: "Asia/Macau",
		value: "Asia/Macau",
	},
	{
		id: "Asia/Magadan",
		value: "Asia/Magadan",
	},
	{
		id: "Asia/Makassar",
		value: "Asia/Makassar",
	},
	{
		id: "Asia/Manila",
		value: "Asia/Manila",
	},
	{
		id: "Asia/Muscat",
		value: "Asia/Muscat",
	},
	{
		id: "Asia/Nicosia",
		value: "Asia/Nicosia",
	},
	{
		id: "Asia/Novokuznetsk",
		value: "Asia/Novokuznetsk",
	},
	{
		id: "Asia/Novosibirsk",
		value: "Asia/Novosibirsk",
	},
	{
		id: "Asia/Omsk",
		value: "Asia/Omsk",
	},
	{
		id: "Asia/Oral",
		value: "Asia/Oral",
	},
	{
		id: "Asia/Phnom_Penh",
		value: "Asia/Phnom_Penh",
	},
	{
		id: "Asia/Pontianak",
		value: "Asia/Pontianak",
	},
	{
		id: "Asia/Pyongyang",
		value: "Asia/Pyongyang",
	},
	{
		id: "Asia/Qatar",
		value: "Asia/Qatar",
	},
	{
		id: "Asia/Qyzylorda",
		value: "Asia/Qyzylorda",
	},
	{
		id: "Asia/Rangoon",
		value: "Asia/Rangoon",
	},
	{
		id: "Asia/Riyadh",
		value: "Asia/Riyadh",
	},
	{
		id: "Asia/Sakhalin",
		value: "Asia/Sakhalin",
	},
	{
		id: "Asia/Samarkand",
		value: "Asia/Samarkand",
	},
	{
		id: "Asia/Seoul",
		value: "Asia/Seoul",
	},
	{
		id: "Asia/Shanghai",
		value: "Asia/Shanghai",
	},
	{
		id: "Asia/Singapore",
		value: "Asia/Singapore",
	},
	{
		id: "Asia/Srednekolymsk",
		value: "Asia/Srednekolymsk",
	},
	{
		id: "Asia/Taipei",
		value: "Asia/Taipei",
	},
	{
		id: "Asia/Tashkent",
		value: "Asia/Tashkent",
	},
	{
		id: "Asia/Tbilisi",
		value: "Asia/Tbilisi",
	},
	{
		id: "Asia/Tehran",
		value: "Asia/Tehran",
	},
	{
		id: "Asia/Tel_Aviv",
		value: "Asia/Tel_Aviv",
	},
	{
		id: "Asia/Thimbu",
		value: "Asia/Thimbu",
	},
	{
		id: "Asia/Thimphu",
		value: "Asia/Thimphu",
	},
	{
		id: "Asia/Tokyo",
		value: "Asia/Tokyo",
	},
	{
		id: "Asia/Tomsk",
		value: "Asia/Tomsk",
	},
	{
		id: "Asia/Ujung_Pandang",
		value: "Asia/Ujung_Pandang",
	},
	{
		id: "Asia/Ulaanbaatar",
		value: "Asia/Ulaanbaatar",
	},
	{
		id: "Asia/Ulan_Bator",
		value: "Asia/Ulan_Bator",
	},
	{
		id: "Asia/Urumqi",
		value: "Asia/Urumqi",
	},
	{
		id: "Asia/Ust-Nera",
		value: "Asia/Ust-Nera",
	},
	{
		id: "Asia/Vientiane",
		value: "Asia/Vientiane",
	},
	{
		id: "Asia/Vladivostok",
		value: "Asia/Vladivostok",
	},
	{
		id: "Asia/Yakutsk",
		value: "Asia/Yakutsk",
	},
	{
		id: "Asia/Yangon",
		value: "Asia/Yangon",
	},
	{
		id: "Asia/Yekaterinburg",
		value: "Asia/Yekaterinburg",
	},
	{
		id: "Asia/Yerevan",
		value: "Asia/Yerevan",
	},
	{
		id: "Atlantic/Azores",
		value: "Atlantic/Azores",
	},
	{
		id: "Atlantic/Bermuda",
		value: "Atlantic/Bermuda",
	},
	{
		id: "Atlantic/Canary",
		value: "Atlantic/Canary",
	},
	{
		id: "Atlantic/Cape_Verde",
		value: "Atlantic/Cape_Verde",
	},
	{
		id: "Atlantic/Faeroe",
		value: "Atlantic/Faeroe",
	},
	{
		id: "Atlantic/Faroe",
		value: "Atlantic/Faroe",
	},
	{
		id: "Atlantic/Jan_Mayen",
		value: "Atlantic/Jan_Mayen",
	},
	{
		id: "Atlantic/Madeira",
		value: "Atlantic/Madeira",
	},
	{
		id: "Atlantic/Reykjavik",
		value: "Atlantic/Reykjavik",
	},
	{
		id: "Atlantic/South_Georgia",
		value: "Atlantic/South_Georgia",
	},
	{
		id: "Atlantic/St_Helena",
		value: "Atlantic/St_Helena",
	},
	{
		id: "Atlantic/Stanley",
		value: "Atlantic/Stanley",
	},
	{
		id: "Australia/ACT",
		value: "Australia/ACT",
	},
	{
		id: "Australia/Adelaide",
		value: "Australia/Adelaide",
	},
	{
		id: "Australia/Brisbane",
		value: "Australia/Brisbane",
	},
	{
		id: "Australia/Broken_Hill",
		value: "Australia/Broken_Hill",
	},
	{
		id: "Australia/Canberra",
		value: "Australia/Canberra",
	},
	{
		id: "Australia/Currie",
		value: "Australia/Currie",
	},
	{
		id: "Australia/Darwin",
		value: "Australia/Darwin",
	},
	{
		id: "Australia/Eucla",
		value: "Australia/Eucla",
	},
	{
		id: "Australia/Hobart",
		value: "Australia/Hobart",
	},
	{
		id: "Australia/LHI",
		value: "Australia/LHI",
	},
	{
		id: "Australia/Lindeman",
		value: "Australia/Lindeman",
	},
	{
		id: "Australia/Lord_Howe",
		value: "Australia/Lord_Howe",
	},
	{
		id: "Australia/Melbourne",
		value: "Australia/Melbourne",
	},
	{
		id: "Australia/NSW",
		value: "Australia/NSW",
	},
	{
		id: "Australia/North",
		value: "Australia/North",
	},
	{
		id: "Australia/Perth",
		value: "Australia/Perth",
	},
	{
		id: "Australia/Queensland",
		value: "Australia/Queensland",
	},
	{
		id: "Australia/South",
		value: "Australia/South",
	},
	{
		id: "Australia/Sydney",
		value: "Australia/Sydney",
	},
	{
		id: "Australia/Tasmania",
		value: "Australia/Tasmania",
	},
	{
		id: "Australia/Victoria",
		value: "Australia/Victoria",
	},
	{
		id: "Australia/West",
		value: "Australia/West",
	},
	{
		id: "Australia/Yancowinna",
		value: "Australia/Yancowinna",
	},
	{
		id: "Brazil/Acre",
		value: "Brazil/Acre",
	},
	{
		id: "Brazil/DeNoronha",
		value: "Brazil/DeNoronha",
	},
	{
		id: "Brazil/East",
		value: "Brazil/East",
	},
	{
		id: "Brazil/West",
		value: "Brazil/West",
	},
	{
		id: "CET",
		value: "CET",
	},
	{
		id: "CST6CDT",
		value: "CST6CDT",
	},
	{
		id: "Canada/Atlantic",
		value: "Canada/Atlantic",
	},
	{
		id: "Canada/Central",
		value: "Canada/Central",
	},
	{
		id: "Canada/Eastern",
		value: "Canada/Eastern",
	},
	{
		id: "Canada/Mountain",
		value: "Canada/Mountain",
	},
	{
		id: "Canada/Newfoundland",
		value: "Canada/Newfoundland",
	},
	{
		id: "Canada/Pacific",
		value: "Canada/Pacific",
	},
	{
		id: "Canada/Saskatchewan",
		value: "Canada/Saskatchewan",
	},
	{
		id: "Canada/Yukon",
		value: "Canada/Yukon",
	},
	{
		id: "Chile/Continental",
		value: "Chile/Continental",
	},
	{
		id: "Chile/EasterIsland",
		value: "Chile/EasterIsland",
	},
	{
		id: "Cuba",
		value: "Cuba",
	},
	{
		id: "EET",
		value: "EET",
	},
	{
		id: "EST",
		value: "EST",
	},
	{
		id: "EST5EDT",
		value: "EST5EDT",
	},
	{
		id: "Egypt",
		value: "Egypt",
	},
	{
		id: "Eire",
		value: "Eire",
	},
	{
		id: "Etc/GMT",
		value: "Etc/GMT",
	},
	{
		id: "Etc/GMT+0",
		value: "Etc/GMT+0",
	},
	{
		id: "Etc/GMT+1",
		value: "Etc/GMT+1",
	},
	{
		id: "Etc/GMT+10",
		value: "Etc/GMT+10",
	},
	{
		id: "Etc/GMT+11",
		value: "Etc/GMT+11",
	},
	{
		id: "Etc/GMT+12",
		value: "Etc/GMT+12",
	},
	{
		id: "Etc/GMT+2",
		value: "Etc/GMT+2",
	},
	{
		id: "Etc/GMT+3",
		value: "Etc/GMT+3",
	},
	{
		id: "Etc/GMT+4",
		value: "Etc/GMT+4",
	},
	{
		id: "Etc/GMT+5",
		value: "Etc/GMT+5",
	},
	{
		id: "Etc/GMT+6",
		value: "Etc/GMT+6",
	},
	{
		id: "Etc/GMT+7",
		value: "Etc/GMT+7",
	},
	{
		id: "Etc/GMT+8",
		value: "Etc/GMT+8",
	},
	{
		id: "Etc/GMT+9",
		value: "Etc/GMT+9",
	},
	{
		id: "Etc/GMT-0",
		value: "Etc/GMT-0",
	},
	{
		id: "Etc/GMT-1",
		value: "Etc/GMT-1",
	},
	{
		id: "Etc/GMT-10",
		value: "Etc/GMT-10",
	},
	{
		id: "Etc/GMT-11",
		value: "Etc/GMT-11",
	},
	{
		id: "Etc/GMT-12",
		value: "Etc/GMT-12",
	},
	{
		id: "Etc/GMT-13",
		value: "Etc/GMT-13",
	},
	{
		id: "Etc/GMT-14",
		value: "Etc/GMT-14",
	},
	{
		id: "Etc/GMT-2",
		value: "Etc/GMT-2",
	},
	{
		id: "Etc/GMT-3",
		value: "Etc/GMT-3",
	},
	{
		id: "Etc/GMT-4",
		value: "Etc/GMT-4",
	},
	{
		id: "Etc/GMT-5",
		value: "Etc/GMT-5",
	},
	{
		id: "Etc/GMT-6",
		value: "Etc/GMT-6",
	},
	{
		id: "Etc/GMT-7",
		value: "Etc/GMT-7",
	},
	{
		id: "Etc/GMT-8",
		value: "Etc/GMT-8",
	},
	{
		id: "Etc/GMT-9",
		value: "Etc/GMT-9",
	},
	{
		id: "Etc/GMT0",
		value: "Etc/GMT0",
	},
	{
		id: "Etc/Greenwich",
		value: "Etc/Greenwich",
	},
	{
		id: "Etc/UCT",
		value: "Etc/UCT",
	},
	{
		id: "Etc/UTC",
		value: "Etc/UTC",
	},
	{
		id: "Etc/Universal",
		value: "Etc/Universal",
	},
	{
		id: "Etc/Zulu",
		value: "Etc/Zulu",
	},
	{
		id: "Europe/Amsterdam",
		value: "Europe/Amsterdam",
	},
	{
		id: "Europe/Andorra",
		value: "Europe/Andorra",
	},
	{
		id: "Europe/Astrakhan",
		value: "Europe/Astrakhan",
	},
	{
		id: "Europe/Athens",
		value: "Europe/Athens",
	},
	{
		id: "Europe/Belfast",
		value: "Europe/Belfast",
	},
	{
		id: "Europe/Belgrade",
		value: "Europe/Belgrade",
	},
	{
		id: "Europe/Berlin",
		value: "Europe/Berlin",
	},
	{
		id: "Europe/Bratislava",
		value: "Europe/Bratislava",
	},
	{
		id: "Europe/Brussels",
		value: "Europe/Brussels",
	},
	{
		id: "Europe/Bucharest",
		value: "Europe/Bucharest",
	},
	{
		id: "Europe/Budapest",
		value: "Europe/Budapest",
	},
	{
		id: "Europe/Busingen",
		value: "Europe/Busingen",
	},
	{
		id: "Europe/Chisinau",
		value: "Europe/Chisinau",
	},
	{
		id: "Europe/Copenhagen",
		value: "Europe/Copenhagen",
	},
	{
		id: "Europe/Dublin",
		value: "Europe/Dublin",
	},
	{
		id: "Europe/Gibraltar",
		value: "Europe/Gibraltar",
	},
	{
		id: "Europe/Guernsey",
		value: "Europe/Guernsey",
	},
	{
		id: "Europe/Helsinki",
		value: "Europe/Helsinki",
	},
	{
		id: "Europe/Isle_of_Man",
		value: "Europe/Isle_of_Man",
	},
	{
		id: "Europe/Istanbul",
		value: "Europe/Istanbul",
	},
	{
		id: "Europe/Jersey",
		value: "Europe/Jersey",
	},
	{
		id: "Europe/Kaliningrad",
		value: "Europe/Kaliningrad",
	},
	{
		id: "Europe/Kiev",
		value: "Europe/Kiev",
	},
	{
		id: "Europe/Kirov",
		value: "Europe/Kirov",
	},
	{
		id: "Europe/Lisbon",
		value: "Europe/Lisbon",
	},
	{
		id: "Europe/Ljubljana",
		value: "Europe/Ljubljana",
	},
	{
		id: "Europe/London",
		value: "Europe/London",
	},
	{
		id: "Europe/Luxembourg",
		value: "Europe/Luxembourg",
	},
	{
		id: "Europe/Madrid",
		value: "Europe/Madrid",
	},
	{
		id: "Europe/Malta",
		value: "Europe/Malta",
	},
	{
		id: "Europe/Mariehamn",
		value: "Europe/Mariehamn",
	},
	{
		id: "Europe/Minsk",
		value: "Europe/Minsk",
	},
	{
		id: "Europe/Monaco",
		value: "Europe/Monaco",
	},
	{
		id: "Europe/Moscow",
		value: "Europe/Moscow",
	},
	{
		id: "Europe/Nicosia",
		value: "Europe/Nicosia",
	},
	{
		id: "Europe/Oslo",
		value: "Europe/Oslo",
	},
	{
		id: "Europe/Paris",
		value: "Europe/Paris",
	},
	{
		id: "Europe/Podgorica",
		value: "Europe/Podgorica",
	},
	{
		id: "Europe/Prague",
		value: "Europe/Prague",
	},
	{
		id: "Europe/Riga",
		value: "Europe/Riga",
	},
	{
		id: "Europe/Rome",
		value: "Europe/Rome",
	},
	{
		id: "Europe/Samara",
		value: "Europe/Samara",
	},
	{
		id: "Europe/San_Marino",
		value: "Europe/San_Marino",
	},
	{
		id: "Europe/Sarajevo",
		value: "Europe/Sarajevo",
	},
	{
		id: "Europe/Saratov",
		value: "Europe/Saratov",
	},
	{
		id: "Europe/Simferopol",
		value: "Europe/Simferopol",
	},
	{
		id: "Europe/Skopje",
		value: "Europe/Skopje",
	},
	{
		id: "Europe/Sofia",
		value: "Europe/Sofia",
	},
	{
		id: "Europe/Stockholm",
		value: "Europe/Stockholm",
	},
	{
		id: "Europe/Tallinn",
		value: "Europe/Tallinn",
	},
	{
		id: "Europe/Tirane",
		value: "Europe/Tirane",
	},
	{
		id: "Europe/Tiraspol",
		value: "Europe/Tiraspol",
	},
	{
		id: "Europe/Ulyanovsk",
		value: "Europe/Ulyanovsk",
	},
	{
		id: "Europe/Uzhgorod",
		value: "Europe/Uzhgorod",
	},
	{
		id: "Europe/Vaduz",
		value: "Europe/Vaduz",
	},
	{
		id: "Europe/Vatican",
		value: "Europe/Vatican",
	},
	{
		id: "Europe/Vienna",
		value: "Europe/Vienna",
	},
	{
		id: "Europe/Vilnius",
		value: "Europe/Vilnius",
	},
	{
		id: "Europe/Volgograd",
		value: "Europe/Volgograd",
	},
	{
		id: "Europe/Warsaw",
		value: "Europe/Warsaw",
	},
	{
		id: "Europe/Zagreb",
		value: "Europe/Zagreb",
	},
	{
		id: "Europe/Zaporozhye",
		value: "Europe/Zaporozhye",
	},
	{
		id: "Europe/Zurich",
		value: "Europe/Zurich",
	},
	{
		id: "GB",
		value: "GB",
	},
	{
		id: "GB-Eire",
		value: "GB-Eire",
	},
	{
		id: "GMT",
		value: "GMT",
	},
	{
		id: "GMT+0",
		value: "GMT+0",
	},
	{
		id: "GMT-0",
		value: "GMT-0",
	},
	{
		id: "GMT0",
		value: "GMT0",
	},
	{
		id: "Greenwich",
		value: "Greenwich",
	},
	{
		id: "HST",
		value: "HST",
	},
	{
		id: "Hongkong",
		value: "Hongkong",
	},
	{
		id: "Iceland",
		value: "Iceland",
	},
	{
		id: "Indian/Antananarivo",
		value: "Indian/Antananarivo",
	},
	{
		id: "Indian/Chagos",
		value: "Indian/Chagos",
	},
	{
		id: "Indian/Christmas",
		value: "Indian/Christmas",
	},
	{
		id: "Indian/Cocos",
		value: "Indian/Cocos",
	},
	{
		id: "Indian/Comoro",
		value: "Indian/Comoro",
	},
	{
		id: "Indian/Kerguelen",
		value: "Indian/Kerguelen",
	},
	{
		id: "Indian/Mahe",
		value: "Indian/Mahe",
	},
	{
		id: "Indian/Maldives",
		value: "Indian/Maldives",
	},
	{
		id: "Indian/Mauritius",
		value: "Indian/Mauritius",
	},
	{
		id: "Indian/Mayotte",
		value: "Indian/Mayotte",
	},
	{
		id: "Indian/Reunion",
		value: "Indian/Reunion",
	},
	{
		id: "Iran",
		value: "Iran",
	},
	{
		id: "Israel",
		value: "Israel",
	},
	{
		id: "Jamaica",
		value: "Jamaica",
	},
	{
		id: "Japan",
		value: "Japan",
	},
	{
		id: "Kwajalein",
		value: "Kwajalein",
	},
	{
		id: "Libya",
		value: "Libya",
	},
	{
		id: "MET",
		value: "MET",
	},
	{
		id: "MST",
		value: "MST",
	},
	{
		id: "MST7MDT",
		value: "MST7MDT",
	},
	{
		id: "Mexico/BajaNorte",
		value: "Mexico/BajaNorte",
	},
	{
		id: "Mexico/BajaSur",
		value: "Mexico/BajaSur",
	},
	{
		id: "Mexico/General",
		value: "Mexico/General",
	},
	{
		id: "NZ",
		value: "NZ",
	},
	{
		id: "NZ-CHAT",
		value: "NZ-CHAT",
	},
	{
		id: "Navajo",
		value: "Navajo",
	},
	{
		id: "PRC",
		value: "PRC",
	},
	{
		id: "PST8PDT",
		value: "PST8PDT",
	},
	{
		id: "Pacific/Apia",
		value: "Pacific/Apia",
	},
	{
		id: "Pacific/Auckland",
		value: "Pacific/Auckland",
	},
	{
		id: "Pacific/Bougainville",
		value: "Pacific/Bougainville",
	},
	{
		id: "Pacific/Chatham",
		value: "Pacific/Chatham",
	},
	{
		id: "Pacific/Chuuk",
		value: "Pacific/Chuuk",
	},
	{
		id: "Pacific/Easter",
		value: "Pacific/Easter",
	},
	{
		id: "Pacific/Efate",
		value: "Pacific/Efate",
	},
	{
		id: "Pacific/Enderbury",
		value: "Pacific/Enderbury",
	},
	{
		id: "Pacific/Fakaofo",
		value: "Pacific/Fakaofo",
	},
	{
		id: "Pacific/Fiji",
		value: "Pacific/Fiji",
	},
	{
		id: "Pacific/Funafuti",
		value: "Pacific/Funafuti",
	},
	{
		id: "Pacific/Galapagos",
		value: "Pacific/Galapagos",
	},
	{
		id: "Pacific/Gambier",
		value: "Pacific/Gambier",
	},
	{
		id: "Pacific/Guadalcanal",
		value: "Pacific/Guadalcanal",
	},
	{
		id: "Pacific/Guam",
		value: "Pacific/Guam",
	},
	{
		id: "Pacific/Honolulu",
		value: "Pacific/Honolulu",
	},
	{
		id: "Pacific/Johnston",
		value: "Pacific/Johnston",
	},
	{
		id: "Pacific/Kiritimati",
		value: "Pacific/Kiritimati",
	},
	{
		id: "Pacific/Kosrae",
		value: "Pacific/Kosrae",
	},
	{
		id: "Pacific/Kwajalein",
		value: "Pacific/Kwajalein",
	},
	{
		id: "Pacific/Majuro",
		value: "Pacific/Majuro",
	},
	{
		id: "Pacific/Marquesas",
		value: "Pacific/Marquesas",
	},
	{
		id: "Pacific/Midway",
		value: "Pacific/Midway",
	},
	{
		id: "Pacific/Nauru",
		value: "Pacific/Nauru",
	},
	{
		id: "Pacific/Niue",
		value: "Pacific/Niue",
	},
	{
		id: "Pacific/Norfolk",
		value: "Pacific/Norfolk",
	},
	{
		id: "Pacific/Noumea",
		value: "Pacific/Noumea",
	},
	{
		id: "Pacific/Pago_Pago",
		value: "Pacific/Pago_Pago",
	},
	{
		id: "Pacific/Palau",
		value: "Pacific/Palau",
	},
	{
		id: "Pacific/Pitcairn",
		value: "Pacific/Pitcairn",
	},
	{
		id: "Pacific/Pohnpei",
		value: "Pacific/Pohnpei",
	},
	{
		id: "Pacific/Ponape",
		value: "Pacific/Ponape",
	},
	{
		id: "Pacific/Port_Moresby",
		value: "Pacific/Port_Moresby",
	},
	{
		id: "Pacific/Rarotonga",
		value: "Pacific/Rarotonga",
	},
	{
		id: "Pacific/Saipan",
		value: "Pacific/Saipan",
	},
	{
		id: "Pacific/Samoa",
		value: "Pacific/Samoa",
	},
	{
		id: "Pacific/Tahiti",
		value: "Pacific/Tahiti",
	},
	{
		id: "Pacific/Tarawa",
		value: "Pacific/Tarawa",
	},
	{
		id: "Pacific/Tongatapu",
		value: "Pacific/Tongatapu",
	},
	{
		id: "Pacific/Truk",
		value: "Pacific/Truk",
	},
	{
		id: "Pacific/Wake",
		value: "Pacific/Wake",
	},
	{
		id: "Pacific/Wallis",
		value: "Pacific/Wallis",
	},
	{
		id: "Pacific/Yap",
		value: "Pacific/Yap",
	},
	{
		id: "Poland",
		value: "Poland",
	},
	{
		id: "Portugal",
		value: "Portugal",
	},
	{
		id: "ROC",
		value: "ROC",
	},
	{
		id: "ROK",
		value: "ROK",
	},
	{
		id: "Singapore",
		value: "Singapore",
	},
	{
		id: "Turkey",
		value: "Turkey",
	},
	{
		id: "UCT",
		value: "UCT",
	},
	{
		id: "US/Alaska",
		value: "US/Alaska",
	},
	{
		id: "US/Aleutian",
		value: "US/Aleutian",
	},
	{
		id: "US/Arizona",
		value: "US/Arizona",
	},
	{
		id: "US/Central",
		value: "US/Central",
	},
	{
		id: "US/East-Indiana",
		value: "US/East-Indiana",
	},
	{
		id: "US/Eastern",
		value: "US/Eastern",
	},
	{
		id: "US/Hawaii",
		value: "US/Hawaii",
	},
	{
		id: "US/Indiana-Starke",
		value: "US/Indiana-Starke",
	},
	{
		id: "US/Michigan",
		value: "US/Michigan",
	},
	{
		id: "US/Mountain",
		value: "US/Mountain",
	},
	{
		id: "US/Pacific",
		value: "US/Pacific",
	},
	{
		id: "US/Pacific-New",
		value: "US/Pacific-New",
	},
	{
		id: "US/Samoa",
		value: "US/Samoa",
	},
	{
		id: "UTC",
		value: "UTC",
	},
	{
		id: "Universal",
		value: "Universal",
	},
	{
		id: "W-SU",
		value: "W-SU",
	},
	{
		id: "WET",
		value: "WET",
	},
	{
		id: "Zulu",
		value: "Zulu",
	},
];

export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
